import * as React from 'react';
import PropTypes from 'prop-types';

/* Material UI */
import {
  Box,
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CardMedia,
  Paper,
} from '@mui/material';

/* React Router */
import { useNavigate } from 'react-router-dom';

/* Project */
import Paths from 'utils/paths';
import { useDispatch } from 'react-redux';
import { clearVehicleInformation } from 'content/features/search-vehicle/searchVehicle.actions';
import { clearReportInformation } from 'content/features/search-report/searchReport.actions';

/* Public */
// import TCITLogo from '/assets/images/TcitLogo_123x50.png';
const SalfaLogo = `${window.location.origin}/images/salfa-rent_1_250x67.jpg`;

function TemporaryDrawer(props) {
  const { side, openByDefault, setOpenDrawer } = props;

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tabValidation = (event) => event.key === 'Tab' || event.key === 'Shift';
  const toggleValidations = (event) => event.type === 'keydown' && tabValidation(event);

  const toggleDrawer = (anchor, open) => (event) => {
    if (toggleValidations(event)) return;

    setState({ ...state, [anchor]: open });
  };

  const goToHome = () => {
    navigate('/');
    setOpenDrawer(false);
  };

  const handleRouteClick = (path) => {
    dispatch(clearVehicleInformation());
    dispatch(clearReportInformation());
    navigate(path);
    setOpenDrawer(false);
  };

  const { publics, shared, protecteds } = Paths;

  const views = [...shared, ...publics, ...protecteds]
    .filter((path) => path.name)
    .map(({ Icon, path, name }) => (
      <ListItem key={path} disablePadding>
        <ListItemButton onClick={() => handleRouteClick(path)}>
          <ListItemIcon>{Icon ? <Icon /> : null}</ListItemIcon>
          <ListItemText primary={name} />
        </ListItemButton>
      </ListItem>
    ));

  const list = (anchor) => (
    <Box
      sx={{ width: ['top', 'bottom'].includes(anchor) ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}>
      <Paper sx={{ height: '120px' }} elevation={2} square>
        <CardMedia
          onClick={() => goToHome()}
          image={SalfaLogo}
          sx={{
            width: '100%',
            // cursor: 'pointer',
            height: '100%',
            backgroundSize: 'auto',
          }}
        />
      </Paper>
      <Divider />
      <List>{views}</List>
    </Box>
  );

  return (
    <Drawer
      anchor={side}
      open={openByDefault}
      onClose={() => setOpenDrawer(false)}
      test-dataid="app-drawer">
      {list(side)}
    </Drawer>
  );
}

TemporaryDrawer.propTypes = {
  setOpenDrawer: PropTypes.func.isRequired,
  side: PropTypes.string,
  openByDefault: PropTypes.bool,
};

TemporaryDrawer.defaultProps = {
  side: 'left',
  openByDefault: false,
};

export default TemporaryDrawer;
